const loadGuestCards = ({ commit }, payload) => {
    commit('LOAD_GUEST_CARDS', payload);
};
/* const setCommunityId = ({commit}, payload) => {
    commit('SET_COMMUNITY_ID', payload);
}; */
const addGuestCard = ({ commit }, payload) => {
    commit('ADD_GUEST_CARD', payload);
};

const updateGuestCard = ({ commit }, payload) => {
    commit('UPDATE_GUEST_CARD', payload);
};

const setGuestCardUUID = ({ commit }, payload) => {
    commit('SET_GUEST_CARD_UUID', payload);
};

// TODO: modify usages of setting of lead source
const setLeadSources = ({ commit }, payload) => {
    commit('SET_LEAD_SOURCES', payload);
};

const setCommOptions = ({ commit }, payload) => {
    commit('SET_COMMUNITY_OPTIONS', payload);
};
const setUnits = ({ commit }, payload) => {
    commit('SET_UNITS', payload);
};
export default {
    loadGuestCards,
    addGuestCard,
    updateGuestCard,
    setGuestCardUUID,
    setLeadSources,
    setCommOptions,
    setUnits,
};
